export default {
    slug: 'exports',
    title: 'Exports',
    visible: [
        "master_user.full_name",
        "status",
        "type",
        "started_at",
        "finished_at",
        "failed_at"
    ],
    listview: 'ExportsListView',
    locales: ['common'],
    showSettingActions: false,
    enableRowSelection: false,
    columns: [],
    view: {
        mode: 'export-tableview'
    },
    customTableContainerClass: 'table-multiline',
    sort: {
        "started_at": "desc"
    },
    permanentFields: [
        "id",
        "user.id",
        "master_user.full_name",
        "status",
        "type",
        "started_at",
        "meta_data",
        "finished_at",
        "failed_at",
        "export_file"
    ],
    actions: {
        download: {
            title: 'Download export',
            level: 'row',
            vm: 'downloadExport'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/exports/state.js